import React, { useState, useEffect } from 'react';
import { StyledCanvas, Container, Menu } from './styled';
import { SearchBox } from './SearchBox';
import { useFamilyTreeCanvas } from './useFamilyTreeCanvas';
import { EditPersonModal } from './EditPersonModal';
import type { FamilyTreeCanvasProps } from './types';

export const FamilyTreeCanvas = ({ people, rootId }: FamilyTreeCanvasProps) => {
  const {
    canvasRef,
    handleCanvasClick,
    handleSelect,
    menuPosition,
    showMenu,
	selectedId
  } = useFamilyTreeCanvas({ people, rootId });

const [showEdit, setShowEdit] = useState(false);
const [peopleMap, setPeopleMap] = useState<any>();

useEffect(() => {
	setPeopleMap(
		people.reduce((all: any, cur: any) => {
			all[cur.id] = cur;
			return all;
		}, {})
	);
}, [people]);

const handleEdit = () => setShowEdit(true);
  return (
    <Container>
      <SearchBox people={people} onSelect={handleSelect} />
      <StyledCanvas ref={canvasRef} onClick={handleCanvasClick} />
      <Menu show={showMenu} x={menuPosition.x} y={menuPosition.y}>
        <div onClick={() => console.log("פרטים")}>פרטים</div>
        <div onClick={() => console.log("הוסף קרוב")}>הוסף קרוב</div>
        <div onClick={handleEdit}>ערוך</div>
      </Menu>
	  {
		showEdit && selectedId ?
			<EditPersonModal
				person={peopleMap[selectedId]}
				onClose={() => setShowEdit(false)}
				onSave={() => setShowEdit(false)}
			/> : ''
	}
    </Container>
  );
};

export default FamilyTreeCanvas;
